import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { Collaborators } from '../get-collaborators/types.tsx';

const URL = '/gateway/api/growth/cross-join-third-party-nudges/get-permitted-users';

type AccountIds = string[];

export const getConfluenceUsers = async (
	collaborators: Collaborators,
	cloudId: string,
): Promise<Collaborators> => {
	try {
		const accountIds = collaborators.map((c) => c.id);
		const confluenceUsers = await fetchJson<AccountIds>(URL, {
			method: 'POST',
			body: JSON.stringify({ cloudId, accountIds, product: 'confluence' }),
		});

		return collaborators.filter((c) => confluenceUsers.includes(c.id));
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'getConfluenceUsers',
				packageName: 'jiraCrossJoinThirdPartyNudges',
			},
			attributes: {
				cloudId,
				accountIds: JSON.stringify(collaborators.map((c) => c.id)),
				errorResponse: getErrorResponse(error),
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw new Error('Get Confluence users error');
	}
};

const getErrorResponse = (error: unknown) => {
	try {
		return JSON.stringify(error);
	} catch (e: unknown) {
		// Swallow error as the error is already in the analytic event.
		return undefined;
	}
};
